import React from 'react';

function StorybookFilters({ categories, selectedCategory, onCategoryChange, selectedAge, onAgeChange, searchTerm, onSearchChange }) {
  const ageRanges = [
    { value: '3-6', label: '3-6 سنوات' },
    { value: '7-10', label: '7-10 سنوات' },
    { value: '11-14', label: '11-14 سنة' },
  ];

  return (
    <div className="mb-12">
      <div className="mb-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        <input
          type="text"
          placeholder="ابحث عن قصة..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full px-6 py-4 rounded-xl border-2 border-gray-200 focus:border-primary focus:outline-none text-lg"
        />
        
        <select
          value={selectedAge || ''}
          onChange={(e) => onAgeChange(e.target.value || null)}
          className="w-full px-6 py-4 rounded-xl border-2 border-gray-200 focus:border-primary focus:outline-none text-lg bg-white"
        >
          <option value="">كل الأعمار</option>
          {ageRanges.map(age => (
            <option key={age.value} value={age.value}>
              {age.label}
            </option>
          ))}
        </select>
      </div>
      
      <div className="flex flex-wrap gap-2 md:gap-3 justify-center">
        <button
          onClick={() => onCategoryChange(null)}
          className={`px-4 py-2 md:px-6 md:py-3 rounded-xl font-bold text-sm md:text-base transition-all duration-300 ${
            selectedCategory === null
              ? 'bg-primary text-white shadow-lg'
              : 'bg-white text-gray-700 hover:bg-gray-100'
          }`}
        >
          الكل
        </button>
        
        {categories.map(category => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`px-4 py-2 md:px-6 md:py-3 rounded-xl font-bold text-sm md:text-base transition-all duration-300 flex items-center gap-1 md:gap-2 ${
              selectedCategory === category.id
                ? 'bg-primary text-white shadow-lg'
                : 'bg-white text-gray-700 hover:bg-gray-100'
            }`}
          >
            <i className={`${category.icon} text-xs md:text-base`}></i>
            {category.name_ar}
          </button>
        ))}
      </div>
    </div>
  );
}

export default StorybookFilters;
